import { IScheduleElementDetails } from "./ScheduleDefinitionModel"
import { StandardOutputModel } from './StandardOutputModel'

export class IRevisionCategory {
    revCategoryId!: number
    revCategory!: string
}
export class IDelayReason {
    delayReasonId!: number
    delayReason!: string
}
export class IScheduleType {
    schType_Id!: number
    schType_Name!: string
}
export interface IScheduleDocRevModel {
    docId: number,
    revisionNo: string,
    docStatus: number,
    isConfidential: boolean,
    printSize: number,
    reference?: string,
    revisedOn?: string,
    reviewedOn?: string,
    revisionCategory: number,
    revisionType: number,
    docAuthorizedBy: number,
    docCreatedBy: number,
    comments?: string
    isFileAttached?: boolean,
    qrCodeStatus: boolean,
    createdBy: number,
    noOfSheets?: number,
    isActive: boolean,
    DCICodeId?: number
}

export interface IScheduleDocModel {
    rowNo?: number,
    projectId: number,
    groupId: number,
    docId?: number,
    docNo: string,
    docTitle: string,
    docSerialNo: number | null,
    module?: number,
    docSetId?: number,
    isScheduled?: boolean,
    docSheetNo?: string,
    userId: number,
    MaxProgressLevel?: number
}

export interface IScheduleDocElementDetails {
    userId: number,
    docId: number,
    deId: number,
    dedId: number,
    isActive: boolean
}

export interface IScheduleWFPlanDetails {
    doc_Id: number,
    revision_No: string,
    docScheduleWFPlanDetails: IScheduleWFPlanStageDetails[],
    is_Active: boolean,
    userId: number
}

export interface IScheduleWFPlanStageDetails {
    sort_By: any,
    status_Id?: number,
    scheduled_On?: string
}

export interface IScheduleDocStageDetails {
    doc_Id: number,
    revision_No: string,
    docScheduleStageDetails: IScheduleStageId[],
    stage_Id?: number,
    is_Active: boolean,
    userId: number
}

export interface IScheduleStageId {
    stage_Id?: number
}

export interface IScheduleMHDetails {
    doc_Id: number,
    weightage: number,
    e_Man_Hours: number,
    d_Man_Hours: number,
    boQ_Id?: number,
    is_Active: boolean,
    userId: number
}

export interface IScheduleDocDetails {
    doc_Id: number,
    revision_No: string,
    from_Group_Id: number,
    to_Group_Id: number,
    scheduled_On?: Date,
    cL_Id?: number,
    schedule_Type: number,
    is_Input_Required: boolean,
    is_Active: boolean,
    userId: number
}

export interface IScheduleWorkflowDetails {
    doc_Id: number,
    revision_No: string,
    workflow_Id: number,
    is_Active: boolean,
    userId: number
}

export interface IScheduleDocInfo {
    doc_Id: number,
    revision_No: string,
    doc_No: string,
    doc_Title: string,
    doc_Set_Id?: number,
    doc_Set_Name: string,
    doc_Status: string,
    doc_Status_Id: null | number,
    print_Size: string,
    print_Size_Id: null | number,
    revision_Category: null | number,
    authorized_By: string,
    created_By: string,
    created_On: Date,
    reference: null | string,
    comments: null | string,
    noOfSheets?: number,
    stages: null | string,
    workflow_Id?: number,
    is_Latest: boolean,
    is_WF_Started: boolean,
    can_Restart_WF: boolean,
    has_Message?: boolean,
    has_Transmittal?: boolean,
    dciScheduleStageDetails: null | IScheduleStageDetails[],
    dciScheduleElementDetails: null | any[],
    isSelected: boolean,
    approved_Tag: boolean,
    approved_On: Date,
    approval_Date?: Date,
    submission_Date?: Date,
    isShowSupersedeIcon: boolean,
    current_Stage?: string,
    current_StageId?: number,
    current_Status?: string,
    isCompleted?: boolean,
    message_Id?: number,
    message_Number?: string,
    schedule_Type?: number,
    is_File_Attached?: boolean,
    is_Confidential?: boolean,
    doc_Serial_No?: number,
    hold?: boolean,
    is_On_Hold?: boolean
    holded_By?: number,
    holded_On?: Date
    reason_for_Hold?: string
    scheduled_On?: Date
    revisedScheduled_On?: Date
}

export interface IScheduleStageDetails {
    stage_Id: number,
    stage_Desc: string,
    stage_Short_Desc: string,
    scheduled_On: Date
    revisedScheduled_On?: Date
}

export interface IScheduleDocApprovalDetails {
    DocSchApproveDetails: IScheduleDocApprovalDocId[],
    approved_Tag: boolean
    userId: number
}

export interface IScheduleDocApprovalDocId {
    doc_Id: number,
    revision_No: string
}

export interface IReviseScheduleDateDocModel {
    docId: number,
    revisionNo: string,
    stageId?: number
}
export interface IScheduleDateUpdateDetails {
    docSchDateDetail: IReviseScheduleDateDocModel[],
    revisedDate: string
    userId: number
}

export interface IScheduleDocUploadStatusModel {
    rowNo: number,
    docNo: string,
    revisionNo: string,
    errors?: string[],
    status?: boolean,
    is_Created?: boolean
}

export interface IDCIBulkSupersedeStatusModel {
    slno: number,
    docNo: string,
    docTitle: string,
    revisionNo: string,
    details?: string,
    status?: boolean
}

export interface IScheduleISODocUploadDetailsModel {
    rowNo: number,
    docNo: string,
    docTitle: string,
    printSize: string,
    noOfSheets: string,
    category: string,
    revisionNo: string,
    scheduled_On: string,
    comments: string,
    errors: string[] | undefined,
    status: boolean | undefined
}

export interface IScheduleBulkInsertModel {
    isStandardDrawingDocument: boolean,
    dciMasterDetails: IScheduleDocModel,
    dciRevDetails: IScheduleDocRevModel,
    dciSchDetails: IScheduleDocDetails,
    dciElementDetails: IScheduleElementDetails | null,
    dciDocScheduleWFPlanDetails?: IScheduleWFPlanDetails | null,
    dciDocSchStageDetails?: IScheduleDocStageDetails | null,
    dciDocSchMHDetails: IScheduleMHDetails,
    dciDocSchWorkflowDetails?: IScheduleWorkflowDetails | null,

}

export interface SDLinkModel {
    intProjectId: number,
    intGroupID: number,
    strjsonDocID: string,
    strjsonElement :  string,
    intWFID: number,
    intApproval: number,
    intReleaseId: number,
    intUID: number
}

export interface StrjsonDocIDModel {
    doc_id: number
}

export interface DCIToStartWorkflow_Output {
    workflowId: number
    roleId: number,
    roleDescription: string,
    selectedMemberId: number,
    roleMembersMapping: roleMembersMappingModel[];
}

export interface roleMembersMappingModel {
    memberId: number,
    memberName: string,
}

export interface DCIToStartWorkflow_Input {
    ProjectId: number,
    GroupId: number,
    jsonDCIWFMapping: startWFInput[]
}

export interface startWFInput {
    documentId: number,
    revisionNumber: string,
    workflowId: number
}

export type StartWFsaveInputModel = {
    documentId: number,
    revisionNumber: string,
    roleId: number,
    memberId: number,
}

export interface WFTransmittalInputModel {
    doc_Id: number,
    revision_No: string,
    task_Id: number
}

export type WFTransmittalOutputModel = {
    doc_Id: number,
    revision_No: string,
    doc_No: string,
    doc_Title: string,
    integration_Type: number,
    transmittal_Page: string,
    task_Id: number
}

export interface IDciWFStageDetails {
    project_Id: number,
    workflow_Id: number
}

export interface IDCISupersedeRevDetailsModel {
    docId: number,
    userId: number,
    printSize: number,
    docStatus: number,
    revCategory: number,
    comments: string,
    noOfSheets?: number
}

export interface IDCISupersedeRevInputModel {
    docId: number,
    revisionNo: string,
    workflowId: number
}

export interface IDCISupersedeRevOutputModel {
    docId: number,
    revisionNo: string,
    canRestartWF: boolean
}

export interface IDCISupersedeRevWFInputModel {
    docId: number,
    revisionNo: string,
    oldWorkflowId: number,
    workflowId: number
}

export interface IDCIPostWorkflowSupersedeModel {
    docId: number,
    revisionNo: string,
    nextRevisionNo: string,
    workflowId: number,
    createdBy: number,
    printSize: number,
    docStatus: number,
    revCategory: number,
    noOfSheets: number,
    comments: string,
    stageDetails: ILatestStageDetails[]
}
export interface IDeleteWorkflowInputModel {
    doc_id: number,
    task_sl_no: number,
    tran_type: string,
    user_id: number
}
export interface IWBSInputModel {
    job_Code: string
}
export interface IDeliverableInputModel {
    job_Code: string,
    wBS_Code: string
}

export interface IWBSOutputModel {
    job_Code: string
    pBS_CODE: string
    wBS_Description: string
}

export interface ICPCDocOutputModel {
    WBS_Code: string
    Deliverable_Code: number
    Expected_Planned_Date: Date
    Actual_Start_Date: Date
    Actual_END_Date: Date
}

export interface ISDInputModel {
    projectId: number
    searchText: string

}

export interface ISDOutputModel {
    doc_Id: number
    doc_No: string
    doc_Title: string
    doc_Serial_No: number
    revision_No: string
    print_Size: string
    isFileAttached: string
    revised_On: Date
    reviewed_On: Date
    discipline: string
    category: string
    sub_Division: string
    doc_Name: string
    file_link: string
}

export interface StdDciGridOutputModel {
    doc_Id: number
    revision_No: string
    doc_No: string
    doc_Title: string
    doc_Status: string
    print_Size: string
    print_Size_Id: number
    authorized_By: string
    created_By: Date
    created_On: string
    discipline: string
    is_File_Attached: boolean
    group_Id: number
    doc_Authorized_By: string
    current_Status: string
    is_Latest?: boolean
}

export interface IWBSOutputModel {
    job_Code: string
    pBS_CODE: string
    wBS_Description: string
}

export interface ICPCDocOutputModel {
    WBS_Code: string
    Deliverable_Code: number
    Expected_Planned_Date: Date
    Actual_Start_Date: Date
    Actual_END_Date: Date
}

export interface ICPCInputModel {
    projectId: number
    docId: number
    wBSCode: string | null
    deliverableCode: number | null
    memberId: number
}

export class ILatestStageDetails {
    doc_Id: number | undefined
    revision_No!: string
    status_Id!: number
    scheduled_On!: string | null
    revisedScheduled_On?: string | null
    is_Active!: boolean
    Stage_Short_Desc!: string
    Stage_Desc!: string
    maxScheduled_On?: string | null
    minScheduled_On?: string | null
    updatedScheduled_On?: string
    isUpdatable!: boolean
}

export interface IDCIPostBulkSupersedeModel {
    index: number,
    doc_Id: number,
    doc_No: string,
    doc_Title: string,
    current_Stage: string,
    current_StageId: number,
    revision_No: string,
    supersede_Revision_No: string,
    revision_Category: number,
    released_For: number,
    print_Size: number,
    schedule_Type: number,
    parentWorkflow: number,
    workflow?: number,
    noOfSheets: number,
    dciScheduleStageDetails: IScheduleStageDetails[],
    comments: string,
    ccnTypeDetails: any[],
    ccnType: number | null,
    tagCCN: number,
    category: number,
    draftingManHours: number,
    designManHours: number,
    latestStageDetails: any[],
    is_WF_Started: boolean,
    isCCNActive: boolean,
}

